// Shared game vocabulary. Keys here must match the ones the cloud functions
// write to `games/<id>/data/gameType` and `games/<id>/winners`.

export const TICKET_ROWS = 3;
export const TICKET_COLS = 9;

export const BOARD_ROWS = 10;
export const BOARD_COLS = 9;

// Tickets are stored as a sparse, column-major map (blanks are simply absent),
// so a cell is addressed by a flat index rather than by [row][column].
export function ticketIndex(row, column) {
  return row + TICKET_ROWS * column - (TICKET_ROWS + 1);
}

// The board reads top-to-bottom in decades: column 1 holds 1-10, column 2
// holds 11-20, and so on.
export function boardNumber(row, column) {
  return column * BOARD_ROWS + row - BOARD_ROWS;
}

// Every claim an admin can enable on a game, in the order they are offered.
export const GAME_TYPES = [
  { key: "corners", label: "Corners" },
  { key: "star", label: "Star" },
  { key: "top_line", label: "Top Line" },
  { key: "middle_line", label: "Mid Line" },
  { key: "bottom_line", label: "Bottom Line" },
  { key: "early_five", label: "Early Five" },
  { key: "early_seven", label: "Early Seven" },
  { key: "box_bonus", label: "Box Bonus" },
  { key: "half_sheet", label: "Half Sheet" },
  { key: "full_sheet", label: "Full Sheet" },
  { key: "fullhouse", label: "First Fullhouse" },
  { key: "fullhouse_2", label: "Second Fullhouse" },
  { key: "fullhouse_3", label: "Third Fullhouse" },
  { key: "fullhouse_4", label: "Fourth Fullhouse" },
  { key: "fullhouse_5", label: "Fifth Fullhouse" }
];

// Only the fullhouse keys need spelling out; the rest read fine once the
// underscores are swapped for spaces.
const WINNER_LABELS = {
  fullhouse: "First Fullhouse",
  fullhouse_2: "Second Fullhouse",
  fullhouse_3: "Third Fullhouse",
  fullhouse_4: "Fourth Fullhouse",
  fullhouse_5: "Fifth Fullhouse"
};

export function winnerLabel(key) {
  return (WINNER_LABELS[key] || String(key).replace(/_/g, " ")).toUpperCase();
}

// Claims are announced with the matching clip in src/assets/sound.
export const WINNER_SOUND = {
  early_five: 91,
  star: 92,
  top_line: 93,
  middle_line: 94,
  bottom_line: 95,
  box_bonus: 96,
  half_sheet: 97,
  fullhouse: 98,
  fullhouse_2: 99,
  fullhouse_3: 100,
  full_sheet: 101,
  corners: 102,
  fullhouse_4: 103,
  fullhouse_5: 104,
  early_seven: 105
};

// Order the winner board shows claims in — biggest prizes first.
export const WINNER_PRIORITY = {
  fullhouse: 1,
  fullhouse_2: 2,
  fullhouse_3: 3,
  fullhouse_4: 4,
  fullhouse_5: 5,
  full_sheet: 6,
  half_sheet: 7,
  top_line: 8,
  middle_line: 9,
  bottom_line: 10,
  star: 11,
  early_five: 12,
  early_seven: 13,
  corners: 14,
  box_bonus: 15
};

export function winnerRank(key) {
  const rank = WINNER_PRIORITY[key];
  return typeof rank === "number" ? rank : 99;
}

// Ticket numbers are displayed (and matched) as zero-padded 3-digit strings.
export function ticketNumber(value) {
  return String(parseInt(value, 10)).padStart(3, "0");
}

// The checkbox grid tracks every claim as true/false; the cloud functions only
// want the enabled ones.
export function enabledGameTypes(gameType) {
  return Object.keys(gameType || {}).reduce((enabled, key) => {
    if (gameType[key]) enabled[key] = true;
    return enabled;
  }, {});
}

// Games are scheduled on the hour. Computed on demand rather than at import
// time, which would go stale in a long-lived tab.
export function defaultScheduleTime() {
  const date = new Date();
  date.setMinutes(0, 0, 0);
  return date;
}
